import React, { useState, useEffect } from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { Resource } from "../../types/resource";

type Props = {
  resource: Resource;
  basePath: string;
};

const HeavyMachineMarker: React.FC<Props> = ({ resource, basePath }) => {
  const [active, setActive] = useState(false);
  const [markerIcon, setMarkerIcon] = useState<google.maps.Icon | undefined>(undefined);

  const onClick = () => {
    setActive(true);
  };
  const onCloseClick = () => {
    setActive(false);
  };

  useEffect(() => {
    const url = resource.subGroupThumbnailUrl;
    if (!url) return;
    const img = new Image();
    img.onload = () => {
      setMarkerIcon({ url, scaledSize: new google.maps.Size(40, 40) });
    };
    img.onerror = () => {
      setMarkerIcon(undefined);
    };
    img.src = url;
  }, [resource.subGroupThumbnailUrl]);

  // 座標が取れていない重機は表示対象外とする
  if (!resource.lat || !resource.lon) return <></>;

  const position = {
    lat: resource.lat,
    lng: resource.lon,
  };

  return (
    <>
      {active && (
        <InfoWindow position={position} onCloseClick={onCloseClick}>
          <div>
            <h4 className="text-md">{resource.name}</h4>
            <dl className="mb-2 text-sm">
              <dt>種別:</dt>
              <dd>
                {resource.groupName} - {resource.subGroupName}
              </dd>
              <dt>場所:</dt>
              <dd>{resource.siteName ?? "なし"}</dd>
              <dt>ステータス:</dt>
              <dd>{resource.operatingStatus}</dd>
            </dl>
            <hr />
            <p>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${resource.lat}%2C${resource.lon}`}
                target="_blank"
                className="text-sm"
                rel="noreferrer"
              >
                Google マップで開く
              </a>
            </p>
            <p>
              <a
                href={`${basePath}/${resource.path}/${resource.categoryId}`}
                target="_blank"
                className="text-sm"
                rel="noreferrer"
              >
                詳細
              </a>
            </p>
          </div>
        </InfoWindow>
      )}
      <Marker onClick={onClick} position={position} icon={markerIcon} />
    </>
  );
};

export default HeavyMachineMarker;
